import { http } from "@/app/lib/http/client";

export const catalogSearchService = {
  search: async (
    catalog: string,
    query: string = '',
    page: number = 1,
    paramQueries: string[] = [],
  ) => {
    const endpoints: Record<string, string> = {
      'products': '/products',
      'users': '/authorization/users',
      'sucursales': '/sucursales',
      'roles': '/authorization/roles',
      'departments': '/departments',
      'units': '/units',
      'categories': '/categories',
      'sat_product_keys': '/sat-product-keys',
      'product_types': '/product-types',
      'doctors': '/pos/doctors'
    };

    const endpoint = endpoints[catalog] || `/${catalog}`;
    const params = new URLSearchParams();

    if (query) {
      params.append('search', query);
    }

    if (page > 1) {
      params.append('page', page.toString());
    }

    if (paramQueries && paramQueries.length > 0) {
      params.append('fields', paramQueries.join(','));
    }

    const response = await http.get(`${endpoint}?${params.toString()}`);
    const data = response.data.data;

    if (data && !Array.isArray(data)) {
      if (data.cash_registers && Array.isArray(data.cash_registers)) {
        return data.cash_registers;
      }
    }

    return data;
  }
}


/*
import {useState }from'react'
import {SearchInput }from'../components/ui/SearchInput'

exportfunctionDelFormulario() {
const [tipoProductoId,setTipoProductoId]=useState('')

return (
<div>
<label>Tipo de Producto</label>
<SearchInput
type="select"
catalog="product_types"
placeholder="Selecciona un tipo..."
onValueChange={(valorSeleccionado)=> {
setTipoProductoId(valorSeleccionado)
        }}
/>
</div>
  )
} */



/*
import {useState }from'react'
import {SearchInput }from'../components/ui/SearchInput'

exportfunctionMiPantalla() {
//  guardar lo que se busca
const [searchQuery,setSearchQuery]=useState('')

return (
<div>
<SearchInput
type="text"
placeholder="Buscar por nombre..."
onSearch={(textoEscrito)=> {
// guardamos el texto y regresamos la tabla a la página 1.
setSearchQuery(textoEscrito)
setCurrentPage(1)
        }}
/>
</div>
  )
}
} */
